import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectEstadosReprogramar = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti,
    tecnologiaTrato,
    tipoTarea = 'TODAS'
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const allOptions = [
      { value: 'Corte de energia', label: 'Corte de energia', tipoTarea:['INSTALACION','ASISTENCIA'] },
      { value: 'Situacion Climatica', label: 'Situacion Climatica', tipoTarea:['TODAS'] },
      { value: 'Corte de Ruta', label: 'Corte de Ruta', tipoTarea:['TODAS'] },
      { value: 'Cuadrilla con incidente', label: 'Cuadrilla con incidente', tipoTarea:['TODAS'] },
      { value: 'Fin de turno - técnico', label: 'Fin de turno - técnico', tipoTarea:['TODAS'] },
      { value: 'Incidente en la red NBC', label: 'Incidente en la red NBC', tipoTarea:['INSTALACION','ASISTENCIA'] },
      { value: 'Falta de Insumos', label: 'Falta de Insumos', tipoTarea:['INSTALACION','ASISTENCIA'] },
      { value: 'Por NBC - Prioridad de tarea', label: 'Por NBC - Prioridad de tarea', tipoTarea:['TODAS'] },
      { value: 'Reprogramada por el Cliente', label: 'Reprogramada por el Cliente', tipoTarea:['TODAS'] },
      { value: 'Por equipo Ausente', label: 'Por equipo Ausente', tipoTarea:['RETIRO'] },
      { value: 'Por trabajo Interno FO', label: 'Por trabajo Interno FO', tipoTarea:['INSTALACION'] },
      { value: 'Finalizada sin éxito', label: 'Finalizada sin éxito', tipoTarea:['TODAS'] },
    ];
    const options = useMemo(() => {
      let filtered = allOptions;

      // Filtrar por tipoTarea solo si no es 'TODAS'
      if (tipoTarea !== 'TODAS') {
        filtered = filtered.filter(opt =>
          opt.tipoTarea.includes(tipoTarea) || opt.tipoTarea.includes('TODAS')
        );
      }

      // Filtrar por tecnologiaTrato solo si tipoTarea no es 'TODAS'
      if (tipoTarea !== 'TODAS' && (tecnologiaTrato === 'RF' || tecnologiaTrato === 'RE')) {
        filtered = filtered.filter(opt => opt.value !== 'Por trabajo Interno FO');
      }

      return filtered;
    }, [tipoTarea, tecnologiaTrato]);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff')
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray'
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        })
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectEstadosReprogramar.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectEstadosReprogramar;